var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup11921(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.413,
    height: 145.413,
    viewBox: "0 0 145.413 145.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11921",
    "data-name": "Group 11921",
    transform: "translate(-510.289 -2550.294)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 72.707,
    cy: 72.707,
    r: 72.707,
    transform: "translate(510.289 2550.294)",
    fill: "#f4f5f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    d: "M546.915,2659.952c-.825-.6-1.049-1.162-.7-1.792a1.41,1.41,0,0,1,1.41-.67q4.942.012,9.884,0h.849v-1.067q0-34.162,0-68.327a6.736,6.736,0,0,1,.06-1,1.164,1.164,0,0,1,1.126-1.03,5.42,5.42,0,0,1,.649-.014h30.8c1.512,0,1.841.335,1.841,1.879q0,13.383,0,26.768v.925h16.727c1.388,0,1.745.357,1.745,1.749q0,19.552,0,39.1v1.016h1.7c1.732,0,3.464.026,5.194-.012a1.715,1.715,0,0,1,1.739.882v1.587Zm29.911-2.481v-39.817c0-1.743.282-2.03,1.99-2.03h11.505v-27.062H560.863v68.887h3.659v-.825c0-3.32-.009-6.639,0-9.959a3.691,3.691,0,0,1,3.845-3.948c.648-.021,1.3-.011,1.948,0,2.59.029,4.04,1.495,4.045,4.1q.009,4.943,0,9.886v.768Zm2.507-.027h29.449v-39.323H579.333Zm-7.512.014a.823.823,0,0,0,.063-.182c0-3.6.016-7.208,0-10.812a1.176,1.176,0,0,0-1.263-1.27c-.647-.032-1.3-.016-1.946-.012-1.312.008-1.7.4-1.7,1.738q0,4.9,0,9.8v.735Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M581.819,2603.291c1.08,0,2.161-.009,3.242,0,1.183.013,1.625.437,1.632,1.6q.02,3.351,0,6.7c-.008,1.109-.476,1.558-1.6,1.563q-3.351.015-6.7,0c-1.078-.007-1.552-.465-1.56-1.531q-.025-3.387,0-6.774c.007-1.088.452-1.535,1.53-1.554C579.513,2603.276,580.666,2603.292,581.819,2603.291Zm-2.473,2.521v4.824h4.843v-4.824Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    d: "M574.363,2608.267c0,1.129.009,2.258,0,3.387-.011,1.01-.441,1.487-1.427,1.5q-3.495.035-6.989,0a1.273,1.273,0,0,1-1.418-1.442q-.02-3.5,0-6.99a1.237,1.237,0,0,1,1.363-1.412q3.566-.045,7.132,0c.918.012,1.324.487,1.337,1.43C574.374,2605.913,574.362,2607.09,574.363,2608.267Zm-2.5,2.393v-4.85h-4.83v4.85Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3255",
    "data-name": "Path 3255",
    d: "M581.739,2600.822c-1.153,0-2.306.015-3.458-.005-.969-.017-1.434-.445-1.445-1.4q-.039-3.5,0-6.99c.009-.987.5-1.442,1.492-1.448q3.421-.021,6.844,0c1.035.006,1.509.459,1.519,1.5q.03,3.423,0,6.846c-.009,1.081-.458,1.5-1.566,1.506C584,2600.832,582.868,2600.823,581.739,2600.822Zm2.444-2.494v-4.85h-4.835v4.85Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M569.482,2625.46c-1.177,0-2.354.011-3.53,0a1.264,1.264,0,0,1-1.426-1.424q-.02-3.5,0-6.99a1.254,1.254,0,0,1,1.428-1.414q3.5-.018,6.989,0a1.237,1.237,0,0,1,1.415,1.417q.021,3.494,0,6.989a1.249,1.249,0,0,1-1.418,1.421C571.788,2625.471,570.635,2625.46,569.482,2625.46Zm2.381-7.323h-4.826v4.827h4.826Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3257",
    "data-name": "Path 3257",
    d: "M564.522,2595.868c0-1.129-.009-2.258,0-3.387.01-1.031.466-1.5,1.5-1.508q3.422-.019,6.844,0c1.035.007,1.486.466,1.491,1.507q.015,3.423,0,6.846c-.005,1.057-.428,1.485-1.49,1.492q-3.423.021-6.845,0c-1.08-.007-1.495-.456-1.5-1.563C564.516,2598.126,564.522,2597,564.522,2595.868Zm7.337,2.456v-4.848h-4.83v4.848Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3258",
    "data-name": "Path 3258",
    d: "M574.362,2632.835c0,1.153.011,2.306,0,3.459-.012,1.022-.427,1.465-1.436,1.473q-3.494.025-6.988,0a1.252,1.252,0,0,1-1.41-1.434q-.018-3.5,0-6.99a1.257,1.257,0,0,1,1.371-1.413q3.566-.034,7.133,0a1.227,1.227,0,0,1,1.325,1.374C574.376,2630.48,574.361,2631.658,574.362,2632.835Zm-2.5-2.4h-4.848v4.822h4.848Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    "data-name": "Path 3259",
    d: "M600.166,2642.712c-1.105,0-2.21.015-3.315,0-1.089-.018-1.54-.456-1.548-1.535q-.024-3.387,0-6.774c.007-1.075.473-1.543,1.541-1.55q3.387-.021,6.773,0c1.074.007,1.538.465,1.546,1.542q.027,3.387,0,6.774c-.008,1.092-.449,1.525-1.54,1.543C602.472,2642.727,601.319,2642.712,600.166,2642.712Zm-2.4-7.36c0,1.538-.014,3.019.023,4.5,0,.134.33.365.513.372.981.038,1.964.019,2.946.019h1.4v-4.889Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    d: "M592.835,2637.76c0,1.153.01,2.306,0,3.459-.011,1.018-.426,1.474-1.433,1.484q-3.493.036-6.988,0a1.258,1.258,0,0,1-1.413-1.438q-.018-3.495,0-6.99a1.273,1.273,0,0,1,1.44-1.42q3.495-.033,6.989,0c.95.01,1.39.492,1.4,1.447C592.846,2635.454,592.835,2636.607,592.835,2637.76Zm-7.3-2.411v4.855h4.789v-4.855Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    d: "M600.205,2630.379c-1.152,0-2.3.011-3.458,0-.955-.012-1.429-.447-1.439-1.41q-.037-3.494,0-6.989c.011-.989.5-1.427,1.5-1.431q3.423-.013,6.844,0c1.038,0,1.5.444,1.513,1.489q.03,3.423,0,6.845c-.008,1.077-.466,1.491-1.571,1.5C602.463,2630.385,601.334,2630.38,600.205,2630.379Zm2.449-2.5v-4.827h-4.826v4.827Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    d: "M600.238,2655.035c-1.129,0-2.258.009-3.387,0-1.073-.012-1.54-.464-1.548-1.542q-.024-3.387,0-6.774c.007-1.09.45-1.526,1.542-1.532q3.386-.018,6.772,0c1.1.006,1.538.435,1.546,1.526q.025,3.387,0,6.773c-.009,1.109-.478,1.542-1.612,1.55C602.447,2655.041,601.342,2655.035,600.238,2655.035Zm2.425-7.346h-4.848v4.83h4.848Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3263",
    "data-name": "Path 3263",
    d: "M587.916,2630.379c-1.153,0-2.306.01-3.458,0-1-.011-1.456-.454-1.461-1.456q-.016-3.459,0-6.918a1.278,1.278,0,0,1,1.467-1.455q3.457-.015,6.917,0c1,0,1.444.45,1.449,1.462q.018,3.459,0,6.918c-.006,1.011-.446,1.439-1.457,1.45C590.222,2630.388,589.069,2630.379,587.916,2630.379Zm2.4-2.5v-4.825H585.49v4.825Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    "data-name": "Path 3264",
    d: "M592.835,2650.084c0,1.153.01,2.306,0,3.458-.012,1.032-.463,1.483-1.51,1.489q-3.386.018-6.772,0c-1.091,0-1.549-.458-1.553-1.529q-.014-3.423,0-6.845c.005-1.007.442-1.464,1.447-1.471q3.5-.026,6.989,0c.968.008,1.385.455,1.4,1.436C592.846,2647.777,592.835,2648.931,592.835,2650.084Zm-2.524,2.459v-4.854H585.5v4.854Z",
    fill: "#f37521"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11921);
export default __webpack_public_path__ + "static/media/Group 11921.94afefceee89cccbb39d82323867293d.svg";
export { ForwardRef as ReactComponent };